import axios from 'axios';

// Configuración de las URLs de la API
const API_URLS = {
    production: 'https://centro-infantil-mijardin.onrender.com/api/finanzas',
    development: 'http://localhost:5000/api/finanzas'
};

// Determinar la URL base según el entorno
const API_URL = process.env.NODE_ENV === 'production' ? API_URLS.production : API_URLS.development;

// Configuración global de axios
axios.defaults.withCredentials = true;

export const registrarEgreso = async (datosEgreso) => {
    try {
        const response = await axios.post(`${API_URL}/registrar/egresos`, datosEgreso, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al registrar el egreso:', error);
        throw new Error('Error al registrar el egreso');
    }
};

export const obtenerEgresos = async () => {
    try {
        const response = await axios.get(`${API_URL}/recuperar/egresos`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener egresos:', error);
        throw new Error('Error al obtener egresos');
    }
};

export const obtenerEgresoPorId = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/recuperar/egresos/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener el egreso:', error);
        throw new Error('Error al obtener el egreso');
    }
};

export const editarEgreso = async (id, datosActualizados) => {
    try {
        const response = await axios.put(`${API_URL}/editar/egresos/${id}`, datosActualizados, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al editar el egreso:', error);
        throw new Error('Error al editar el egreso');
    }
};

export const eliminarEgreso = async (id) => {
    try {
        const response = await axios.delete(`${API_URL}/eliminar/egresos/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al eliminar el egreso:', error);
        throw new Error('Error al eliminar el egreso');
    }
};

export const obtenerHistorialPagos = async () => {
    try {
        const response = await axios.get(`${API_URL}/historial-pagos`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener historial de pagos:', error);
        throw new Error('Error al obtener historial de pagos');
    }
};

export const obtenerHistorialPagoPorId = async (id) => {
    try {
        const response = await axios.get(`${API_URL}/historial-pagos/${id}`, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error al obtener el historial de pago:', error);
        throw new Error('Error al obtener el historial de pago');
    }
};